import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import AccountAvatarForm from "@/features/account/accountAvatarForm"
import AccountDeleteAvatarForm from "@/features/account/accountDeleteAvatarForm"

const AvatarSettingsPage = () => {

    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t('titleAvatarSettings')} />
            <Section>
                <AccountAvatarForm />
            </Section>
            <Section>
                <AccountDeleteAvatarForm />
            </Section>
            <RightSidebar />
        </>
    )
}

export default AvatarSettingsPage
